export const submissionPages = {
  BOOKING_SUBMIT: 'BOOKING_SUBMIT',
  BOOKING_SUBMIT_ADMIN: 'BOOKING_SUBMIT_ADMIN',
  RESULT: 'RESULT',
  RESULTS: 'RESULTS',
  RESULTS_DEEPDIVE: 'RESULTS_DEEPDIVE',
  SUBMISSION_GROUP: 'SUBMISSION_GROUP',
  SUBMISSIONS: 'SUBMISSIONS',
  SUBMIT: 'SUBMIT',
  EDIT_SUBMISSION: 'EDIT_SUBMISSION',
  EDIT_SUBMISSION_ADMIN: 'EDIT_SUBMISSION_ADMIN',
};
